module.exports = __webpack_public_path__ + "img/jqy-app.6f85e782.jpeg";